import {Notification} from "components";

export const {types} = Notification;

export const NAME = "core-notification";

export const HIDE_TIME = 4000;
export const ERROR_HIDE_TIME = 15000;
